module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/flow-image03-7c3997b077cddebcc5f51a1587ff5778.png";